import { useEffect, useRef } from "react";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { organizationApi } from "../../../../../../../../../services/Api/Organization/organizationApi";
import { SubscriptionInvoiceApi } from "../../../../../../../../../services/Api/Subscription/subscriptionTypes";

interface Props {
	invoice: SubscriptionInvoiceApi;
	handleUpdate: (data: string) => void;
}

const InvoicePaymentStatus = (props: Props) => {
	const { invoice, handleUpdate } = props;
	const { addFlash } = useFlash();
	const firstRender = useRef(true);

	useEffect(() => {
		if (firstRender.current) {
			checkStatus();
			firstRender.current = false;
		}

		const interval = setInterval(() => checkStatus(), 3000);

		return () => clearInterval(interval);
	}, [invoice.status]);

	const checkStatus = async () => {
		try {
			const res = await organizationApi.getSubscriptionInvoicePaymentStatus(invoice?.proforma_id);
			handleUpdate(res);
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	return <></>;
};
export default InvoicePaymentStatus;
